import { useCallback, useState } from 'react';
import { guardedClient } from '../../../auth/api/clients';
import {
  BulkCreateAdvisorItem,
  BulkCreateAdvisorsResponse,
  bulkCreateAdvisorsResponseSchema,
} from '@minutes-system/backend/src/api/advisors/schema';
import fetchAndValidate from '../../../../lib/fetchAndValidate';
import { refreshAllAdvisorsCache } from '../../../../states/statesUtil';

interface UseCreateAdvisorsReturn {
  results: BulkCreateAdvisorsResponse | null;
  createAdvisors: (data: BulkCreateAdvisorItem[]) => Promise<BulkCreateAdvisorsResponse>;
}

const useCreateAdvisors = (): UseCreateAdvisorsReturn => {
  const [results, setResults] = useState<BulkCreateAdvisorsResponse | null>(null);

  const createAdvisors = useCallback(
    async (data: BulkCreateAdvisorItem[]) => {
      const response = await guardedClient.advisors.$post({ json: data });
      const validated = await fetchAndValidate(Promise.resolve(response), bulkCreateAdvisorsResponseSchema);
      refreshAllAdvisorsCache();
      setResults(validated);
      return validated;
    },
    [setResults]
  );

  return { results, createAdvisors };
};

export default useCreateAdvisors;
